import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import { Route, BrowserRouter } from "react-router-dom";
import { store } from "./app/store";
import { Provider } from "react-redux";
import * as serviceWorker from "./serviceWorker";
import App from "./App";
import Auth from "./components/Auth/Auth";
import Home from "./components/Home/Home";
import TenpoCheck from "./components/TenpoCheck/Register/TenpoCheck";
import TenpoCheckSearch from "./components/TenpoCheck/Search/TenpoCheckSearch";
import TenpoCheckFilingStatusConfirm from "./components/TenpoCheck/FilingStatusConfirm/TenpoCheckFilingStatusConfirm";
import TenpoCheckManagerAnalysis from "./components/TenpoCheck/ManagerAnalysis/TenpoCheckManagerAnalysis";
import OneVision from "./components/OneVision/Register/OneVision";
import OneVisionOld from "./components/OneVision/RegisterOld/OneVision";
import OneVisionManagerAnalysis from "./components/OneVision/ManagerAnalysis/OneVisionManagerAnalysis";
import OneVisionManagerAnalysisOld from "./components/OneVision/ManagerAnalysisOld/OneVisionManagerAnalysis";
import TSCheck from "./components/TSCheck/Register/TSCheck";
import TSCheckSearch from "./components/TSCheck/Search/TSCheckSearch";
import TSCheckFilingStatusConfirm from "./components/TSCheck/FilingStatusConfirm/TSCheckFilingStatusConfirm";
import OneVisionSearch from "./components/OneVision/Search/OneVisionSearch";
import OneVisionSearchOld from "./components/OneVision/SearchOld/OneVisionSearch";
import OneVisionFilingStatusConfirm from "./components/OneVision/FilingStatusConfirm/OneVisionFilingStatusConfirm";
import TSCheckManagerAnalysis from "./components/TSCheck/ManagerAnalysis/TSCheckManagerAnalysis";
import TSCheckOld from "./components/TSCheck/RegisterOld/TSCheck";
import TSCheckSearchOld from "./components/TSCheck/SearchOld/TSCheckSearch";
import TSCheckManagerAnalysisOld from "./components/TSCheck/ManagerAnalysisOld/TSCheckManagerAnalysis";
import TemplateRegist from "./components/TenpoCheck/Template/TemplateRegist";
import KeieiShindan from "./components/KeieiShindan/Register/KeieiShindan";
import KeieiShindanOld from "./components/KeieiShindan/RegisterOld/KeieiShindan";
import KeieiShindanSearch from "./components/KeieiShindan/Search/KeieiShindanSearch";
import KeieiShindanSearchOld from "./components/KeieiShindan/SearchOld/KeieiShindanSearch";
import KeieiShindanFilingStatusConfirm from "./components/KeieiShindan/FilingStatusConfirm/KeieiShindanFilingStatusConfirm";
import KeieiShindanManagerAnalysis from "./components/KeieiShindan/ManagerAnalysis/KeieiShindanManagerAnalysis";
import KeieiShindanManagerAnalysisOld from "./components/KeieiShindan/ManagerAnalysisOld/KeieiShindanManagerAnalysis";

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <>
          <Route exact path="/login" component={Auth} />
          <Route exact path="/home" component={Home} />
          <Route exact path="/tenpo-check" component={TenpoCheck} />
          <Route
            exact
            path="/tenpo-check-search"
            component={TenpoCheckSearch}
          />
          <Route
            exact
            path="/tenpo-check-filing-status-confirm"
            component={TenpoCheckFilingStatusConfirm}
          />
          <Route
            exact
            path="/tenpo-check-manager-analysis"
            component={TenpoCheckManagerAnalysis}
          />
          <Route
            exact
            path="/tenpo-check-template"
            component={TemplateRegist}
          />
          <Route exact path="/one-vision" component={OneVision} />
          <Route exact path="/one-vision-old" component={OneVisionOld} />
          <Route exact path="/one-vision-search" component={OneVisionSearch} />
          <Route exact path="/one-vision-search-old" component={OneVisionSearchOld} />
          <Route
            exact
            path="/one-vision-filing-status-confirm"
            component={OneVisionFilingStatusConfirm}
          />
          <Route
            exact
            path="/one-vision-manager-analysis"
            component={OneVisionManagerAnalysis}
          />
          <Route
            exact
            path="/one-vision-manager-analysis-old"
            component={OneVisionManagerAnalysisOld}
          />
          <Route exact path="/ts-check" component={TSCheck} />
          <Route exact path="/ts-check-search" component={TSCheckSearch} />
          <Route
            exact
            path="/ts-check-filing-status-confirm"
            component={TSCheckFilingStatusConfirm}
          />
          <Route
            exact
            path="/ts-check-manager-analysis"
            component={TSCheckManagerAnalysis}
          />
          <Route exact path="/ts-check-old" component={TSCheckOld} />
          <Route exact path="/ts-check-search-old" component={TSCheckSearchOld} />
          <Route
            exact
            path="/ts-check-manager-analysis-old"
            component={TSCheckManagerAnalysisOld}
          />
          <Route exact path="/keiei-shindan" component={KeieiShindan} />
          <Route exact path="/keiei-shindan-old" component={KeieiShindanOld} />
          <Route
            exact
            path="/keiei-shindan-search"
            component={KeieiShindanSearch}
          />
          <Route
            exact
            path="/keiei-shindan-search-old"
            component={KeieiShindanSearchOld}
          />
          <Route
            exact
            path="/keiei-shindan-filing-status-confirm"
            component={KeieiShindanFilingStatusConfirm}
          />
          <Route
            exact
            path="/keiei-shindan-manager-analysis"
            component={KeieiShindanManagerAnalysis}
          />
          <Route
            exact
            path="/keiei-shindan-manager-analysis-old"
            component={KeieiShindanManagerAnalysisOld}
          />
          <Route path="/" component={App} />
        </>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

serviceWorker.unregister();
